import ServiceTemplate from '@/components/ServiceTemplate';

export default function OfficeActions() {
  const data = {
    title: 'Support and Response for Trademark Office Actions',
    subtitle: 'Expert responses to USPTO office actions to keep your application on track.',
    overviewTitle: 'Understanding Trademark Office Actions',
    overviewImage: 'https://images.unsplash.com/photo-1619878473858-ace2b236897c',
    description: [
      'Office actions are official communications from the USPTO examining attorney raising concerns about your trademark application. These can include issues with likelihood of confusion, descriptiveness, or technical deficiencies.',
      'Responding properly to office actions is critical - an inadequate response can result in application abandonment. Most office actions have a 6-month deadline for response.',
      'Our experienced trademark attorneys analyze each office action, develop strategic responses, and prepare comprehensive arguments to overcome USPTO objections and move your application toward registration.'
    ],
    benefits: [
      { title: 'Expert Analysis', description: 'Experienced attorneys review and assess each office action.' },
      { title: 'Strategic Response', description: 'Develop effective arguments to overcome objections.' },
      { title: 'Deadline Management', description: 'Ensure timely responses to avoid abandonment.' },
      { title: 'Legal Arguments', description: 'Prepare comprehensive legal and factual arguments.' },
      { title: 'Amendment Assistance', description: 'Make necessary application amendments when beneficial.' },
      { title: 'Success Maximization', description: 'Increase chances of overcoming USPTO objections.' }
    ],
    process: [
      { title: 'Analysis & Strategy', description: 'Thorough review of issues and development of comprehensive response strategy.' },
      { title: 'Response Preparation & Filing', description: 'Expert drafting and timely filing of all required responses and documentation.' },
      { title: 'Follow-Up & Resolution', description: 'Monitoring progress and ensuring successful resolution of all matters.' }
    ],
    pricing: [
      {
        name: 'Basic',
        description: 'Essential trademark filing',
        price: '$599',
        period: '+ USPTO fees ($250-$350)',
        features: [
          'Preliminary trademark search',
          'Single class filing',
          'USPTO application preparation',
          'Filing with USPTO',
          'Email support',
          'Status monitoring'
        ]
      },
      {
        name: 'Professional',
        description: 'Complete trademark package',
        price: '$999',
        period: '+ USPTO fees',
        featured: true,
        features: [
          'Everything in Basic',
          'Comprehensive search report',
          'Multi-class discounts available',
          'Office action response (1 included)',
          'Priority processing',
          'Trademark monitoring (6 months)',
          'Phone & email support'
        ]
      },
      {
        name: 'Premium',
        description: 'Full-service trademark protection',
        price: '$1,499',
        period: '+ USPTO fees',
        features: [
          'Everything in Professional',
          'Global trademark search',
          'Unlimited office action responses',
          'International filing coordination',
          'Trademark monitoring (12 months)',
          'Enforcement support',
          'Dedicated attorney access'
        ]
      }
    ],
    faqs: [
      { question: 'How long do I have to respond?', answer: 'Most office actions require a response within 6 months, though earlier responses can expedite the process.' },
      { question: 'What types of issues do office actions raise?', answer: 'Common issues include likelihood of confusion with existing marks, descriptiveness, incorrect classification, and specimen problems.' },
      { question: 'Can all office actions be overcome?', answer: 'While not all objections can be overcome, experienced representation significantly increases success rates.' },
      { question: 'What happens if I don\'t respond?', answer: 'Failure to respond within the deadline results in application abandonment. The USPTO does not provide reminders, so timely response is critical.' },
      { question: 'How much does it cost to respond to an office action?', answer: 'Response costs vary based on the complexity of issues raised. We provide quotes after reviewing the specific office action.' },
      { question: 'What is a likelihood of confusion rejection?', answer: 'This occurs when the USPTO believes your mark is too similar to an existing registration, potentially causing consumer confusion.' },
      { question: 'Can I amend my application in response?', answer: 'Yes, you can amend the description of goods/services, disclaimer portions, or make other changes to overcome objections.' },
      { question: 'Will I receive more than one office action?', answer: 'It\'s possible to receive multiple office actions if initial responses don\'t fully address examiner concerns or new issues arise.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
